module.exports = __webpack_public_path__ + "img/8.fab07faa.webp";